import { createIcon } from './createIcon'

export const ControlsIcon = createIcon({
  displayName: 'ControlsIcon',
  viewBox: '8 8 16 16',
  path: [
    <path
      d="M15 18.25C15 17.1454 14.1046 16.25 13 16.25C11.8954 16.25 11 17.1454 11 18.25C11 19.3546 11.8954 20.25 13 20.25C14.1046 20.25 15 19.3546 15 18.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />,
    <path
      d="M13 16.25L13 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M13 22.5L13 20.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M21 13.25C21 12.1454 20.1046 11.25 19 11.25C17.8954 11.25 17 12.1454 17 13.25C17 14.3546 17.8954 15.25 19 15.25C20.1046 15.25 21 14.3546 21 13.25Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M19 15.25L19 22.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M19 9L19 11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
